import { FC, Fragment, useState } from 'react';

import { useTranslation } from 'next-i18next';

import BundleFooterBanner from './bundleBanner/footer';
import BundleHeaderBanner from './bundleBanner/header';
import BundleCourseItemsSection from './bundleCourseItemsSection';
import BundleDescription from './bundleDescription';

import CourseSuggestion from '@components/store/product/courseSuggestion';
import ProductNavigationMenu, { ProductNavigationMenuItem } from '@components/store/product/productNavigationMenu';
import ProductPaymentStep from '@components/store/product/productPaymentStep';
import useBundleCourseItem from '@hooks/bundle/useBundleCourseItem';
import { BundleEntity } from '@redux/bundle/type/BundleDetailType';
import ScrollTop from '@components/atoms/scrollTop';

type BundleDetailSectionProps = {
  bundleDetailSeo: BundleEntity;
};

const BUNDLE_PRESET_MENUS = {
  DESCRIPTION: 'description',
  BUNDLE_COURSES: 'bundle_courses',
  PAYMENT_STEP: 'payment-step',
};

const BundleDetailSection: FC<BundleDetailSectionProps> = ({ bundleDetailSeo }) => {
  const { t } = useTranslation('store_course');
  const { bundleCourses, isBundleCoursesSuccess } = useBundleCourseItem();

  const [headerHeight, setHeaderHeight] = useState<number>(0);

  const menus: ProductNavigationMenuItem[] = [
    {
      label: t('bundle_detail.navigation_menu.course_detail'),
      value: BUNDLE_PRESET_MENUS.DESCRIPTION,
    },
    {
      label: t('bundle_detail.navigation_menu.bundle_courses', { courseCount: bundleCourses.length }),
      value: BUNDLE_PRESET_MENUS.BUNDLE_COURSES,
    },
    {
      label: t('bundle_detail.navigation_menu.course_payment_step'),
      value: BUNDLE_PRESET_MENUS.PAYMENT_STEP,
    },
  ];

  const RenderSuggestionSection = bundleCourses.length > 0 && isBundleCoursesSuccess && (
    <CourseSuggestion courseIdName={bundleCourses[0].idName} />
  );

  return (
    <Fragment>
      <BundleHeaderBanner
        bundleDetailSeo={bundleDetailSeo}
        onHeaderSizeChange={(height: number) => setHeaderHeight(height)}
      />

      <ProductNavigationMenu defaultMenu={BUNDLE_PRESET_MENUS.DESCRIPTION} menus={menus} />
      <BundleDescription scrollElementName={BUNDLE_PRESET_MENUS.DESCRIPTION} bundleDetailSeo={bundleDetailSeo} />

      <BundleCourseItemsSection
        scrollElementName={BUNDLE_PRESET_MENUS.BUNDLE_COURSES}
        bundleDetailSeo={bundleDetailSeo}
      />

      <ProductPaymentStep scrollElementName={BUNDLE_PRESET_MENUS.PAYMENT_STEP} />
      {RenderSuggestionSection}

      <ScrollTop bottom={170} scrollDuration={0} />

      <BundleFooterBanner headerHeight={headerHeight} bundleDetailSeo={bundleDetailSeo} />
    </Fragment>
  );
};

export default BundleDetailSection;
